import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=8bdd7766&scoped=true&"
import script from "./DashBoard.vue?vue&type=script&lang=js&"
export * from "./DashBoard.vue?vue&type=script&lang=js&"
import style0 from "./DashBoard.vue?vue&type=style&index=0&id=8bdd7766&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdd7766",
  null
  
)

export default component.exports